@if (application(); as application) {
  <h3>
    Wnioskodawca
  </h3>
  <app-accordion-group>
    @for (applicant of application.applicants; track $index) {
      <app-accordion-item
        [disabled]='false'
        [name]='$index + 1 + ". " + (applicant | entityLabel)'
        [expanded]='expanded'>
        <app-applicant-item-preview [applicant]='applicant'></app-applicant-item-preview>
      </app-accordion-item>
    }
  </app-accordion-group>
  @if (application.isFiledByProxy) {
    <br>
    <h3>
      Pełnomocnik
    </h3>
    <div class='row'>
      <div class='col-md-4'>
        <app-label label='Imię:'>
          {{ application?.proxyFirstName || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Nazwisko:'>
          {{ application?.proxyLastName || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='E-mail:'>
          {{ application?.proxyEmail || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Numer telefonu:'>
          {{ application?.proxyPhone || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='E-mail:'>
          {{ application?.proxyEmail || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Kod pocztowy:'>
          {{ application?.proxyPostalCode || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Poczta:'>
          {{ application?.proxyPostOffice || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Miejscowość:'>
          {{ application?.proxyCity || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Ulica:'>
          {{ application?.proxyCity || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Nr domu:'>
          {{ application?.proxyHouseNumber || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Nr mieszkania:'>
          {{ application?.proxyApartmentNumber || '-' }}
        </app-label>
      </div>
    </div>
  }
}
